import { ListFaq } from './list-faq';

export default ListFaq;